import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'wicg-inert';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import 'vue-tour/dist/vue-tour.css';

import Vue from 'vue';
import App from './App.vue';
import {router} from './router';
import {store} from './store';
import {sync} from 'vuex-router-sync';
import LogRocket from 'logrocket';
import {install} from '@mobi-components/amex-bluesky-components';
import VueGtag from 'vue-gtag';
import VueScrollTo from 'vue-scrollto';
// @ts-ignore
import {init} from 'mobi-axe-helper';
import VueTour from 'vue-tour';

import {datadogRum} from '@datadog/browser-rum';

if (process.env.VUE_APP_DATALOG_ENV) {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DATALOG_APP_ID,
    clientToken: process.env.VUE_APP_DATALOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: process.env.VUE_APP_DATALOG_SERVICE,
    env: process.env.VUE_APP_DATALOG_ENV,
    version: process.env.VUE_APP_VERSION,
    sampleRate: 100,
    trackInteractions: true,
  });
}

function setTourStatus(tour: string) {
  try {
    const tourStatus = localStorage.getItem(tour);
    if (tourStatus !== 'completed' && tourStatus !== 'cancelled') {
      localStorage.setItem(tour, 'enabled');
    }
  } catch (e) {
    console.error(e);
  }
}

setTourStatus('home-tour');
setTourStatus('summary-tour');
setTourStatus('explore-tour');

Vue.use(
  VueGtag,
  {
    config: {id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID},
  },
  router,
);

Vue.use(VueTour);

install({
  load: {
    key: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: 'places',
    v: '3.exp',
  },
  installComponents: false,
});

Vue.use(VueScrollTo);
init();

if (process.env.VUE_APP_ID) {
  LogRocket.init(process.env.VUE_APP_ID, {
    release: process.env.VUE_APP_VERSION,
  });
}

Vue.config.productionTip = false;
sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
